var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 18.7038C5.18528 18.7038 1.29639 14.8149 1.29639 10.0001C1.29639 5.18528 5.18528 1.29639 10.0001 1.29639C14.8149 1.29639 18.7038 5.18528 18.7038 10.0001C18.7038 14.8149 14.8149 18.7038 10.0001 18.7038ZM10.0001 3.14824C6.20379 3.14824 3.14824 6.20379 3.14824 10.0001C3.14824 13.7964 6.20379 16.8519 10.0001 16.8519C13.7964 16.8519 16.8519 13.7964 16.8519 10.0001C16.8519 6.20379 13.7964 3.14824 10.0001 3.14824ZM13.9816 8.42602L12.6853 7.12972L8.98157 10.8334L7.4075 9.25935L6.1112 10.5556L8.98157 13.426L13.9816 8.42602Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.498c86db0f0497185a6c4c7f997d9d87.svg";
export { ForwardRef as ReactComponent };